// extracted by mini-css-extract-plugin
export default {"button":"FullScreenButton_button__uFVB3"};